"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.positive = void 0;
var positive = {
  50: '#E4F7F3',
  100: '#BBEAE2',
  200: '#8DDCCE',
  300: '#5FCEBA',
  400: '#3DC4AC',
  500: '#1BB99D',
  600: '#18B295',
  700: '#14AA8B',
  800: '#10A281',
  900: '#08936F'
};
exports.positive = positive;
//# sourceMappingURL=positive.js.map